import {FlexContainer} from "../../../../../design";
import {Row} from "react-awesome-styled-grid";
import Support from "../../../../../components/support";
import SmallScreenView from "../../../../../components/smallscreen";
import React from "react";

type Props = {
  support: Object,
  whiteLabel: Boolean,
}

const InvoiceFooter = (props:Props) => {
  const {support, whiteLabel} = props;
  return (
    <SmallScreenView sm xs>
      <FlexContainer
        display="block"
        borderRadius="3px"
        boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
        className="text-center p-2 py-3 mx-1 bg-white mb-3"
      >
        <Row className="w-100 px-3 align-items-center">
          <Support email={support && support.email} phone={support && support.phone} whiteLabel={whiteLabel} />
        </Row>
      </FlexContainer>
    </SmallScreenView>
  )
};

export default InvoiceFooter
